module.exports = __webpack_public_path__ + "img/pet_cura.b197b201.jpg";